import React, {useState} from "react";

function InputControl(props) {
    let type = props.type ? props.type : 'text';
    const showHint = !!props.hint && !props.error;
    const classNameList = 'field ' + (props.value ? ' filled ' : '') + (props.error ? ' error ' : '')
    return (<div className='field-container'>
        <label>
            <input className={classNameList}
                   onChange={(event) => props.onChange({name: props.name, value: event.target.value})}
                   onBlur={(event) => props.onFocusLeave(props.name)}
                   name={props.name}
                   type={type}
                   value={props.value}
            />
            <span className="placeholder">{props.placeholder}{starRequired()}</span>
        </label>
        {showHint && <span className='hint'>{props.hint}</span>}
        {props.error && error(props.error)}
    </div>)
}

function PasswordInputControl(props) {

    const [isShowPassword, setShowPassword] = useState(false);
    const eye = isShowPassword ? eyeOpen : eyeClosed;
    const type = isShowPassword ? "text" : "password";
    const showHint = !!props.hint && !props.error;
    const classNameList = 'field ' + (props.value ? ' filled ' : '') + (props.error ? ' error ' : '')

    return (<div className='field-container'>
        <label>
            <input className={classNameList}
                   onChange={(event) => props.onChange({name: props.name, value: event.target.value})}
                   onBlur={(event) => props.onFocusLeave(props.name)}
                   name={props.name}
                   type={type}
                   value={props.value}
            />
            <span className="placeholder">{props.placeholder}{starRequired()}</span>
        </label>
        {eye(() => setShowPassword(!isShowPassword))}
        {showHint && <span className='hint'>{props.hint}</span>}
        {props.error && error(props.error)}
    </div>)
}

function error(value) {
    return (
        <span className="error-text">{value}</span>
    );
}


function eyeOpen(clickHandler) {
    return (
        <svg className='eye' onClick={clickHandler} width="20" height="14" viewBox="0 0 20 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.99998 0.75C5.83331 0.75 2.27498 3.34167 0.833313 7C2.27498 10.6583 5.83331 13.25 9.99998 13.25C14.1666 13.25 17.725 10.6583 19.1666 7C17.725 3.34167 14.1666 0.75 9.99998 0.75ZM9.99998 11.1667C7.69998 11.1667 5.83331 9.29999 5.83331 6.99999C5.83331 4.69999 7.69998 2.83333 9.99998 2.83333C12.3 2.83333 14.1666 4.69999 14.1666 6.99999C14.1666 9.29999 12.3 11.1667 9.99998 11.1667ZM10 4.5C8.61667 4.5 7.5 5.61667 7.5 7C7.5 8.38333 8.61667 9.5 10 9.5C11.3833 9.5 12.5 8.38333 12.5 7C12.5 5.61667 11.3833 4.5 10 4.5Z"
                  fill="#AFBDD1"/>
        </svg>
    )
}

function eyeClosed(clickHandler) {
    return (
        <svg className='eye' onClick={clickHandler} width="20" height="17" viewBox="0 0 20 17" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 3.83333C12.3 3.83333 14.1667 5.7 14.1667 8C14.1667 8.54167 14.0583 9.05 13.8667 9.525L16.3 11.9583C17.5583 10.9083 18.55 9.55 19.1583 8C17.7167 4.34167 14.1583 1.75 9.99167 1.75C8.82501 1.75 7.70834 1.95833 6.67501 2.33333L8.47501 4.13333C8.95001 3.94167 9.45834 3.83333 10 3.83333ZM1.66668 1.55833L3.56668 3.45833L3.95001 3.84167C2.56668 4.91667 1.48334 6.35 0.833344 8C2.27501 11.6583 5.83334 14.25 10 14.25C11.2917 14.25 12.525 14 13.65 13.55L14 13.9L16.4417 16.3333L17.5 15.275L2.72501 0.5L1.66668 1.55833ZM6.27501 6.16667L7.56668 7.45833C7.52501 7.63333 7.50001 7.81667 7.50001 8C7.50001 9.38334 8.61668 10.5 10 10.5C10.1833 10.5 10.3667 10.475 10.5417 10.4333L11.8333 11.725C11.275 12 10.6583 12.1667 10 12.1667C7.70001 12.1667 5.83334 10.3 5.83334 8C5.83334 7.34167 6.00001 6.725 6.27501 6.16667ZM9.86665 5.51667L12.4917 8.14167L12.5083 8.00834C12.5083 6.625 11.3917 5.50833 10.0083 5.50833L9.86665 5.51667Z"
                  fill="#AFBDD1"/>
        </svg>
    )
}

function starRequired() {
    return (<span className="star-required">*</span>)
}

export {InputControl, PasswordInputControl, error}
